<template>
  <CosmoClawTextOverlay v-if="detail" :max-width="780" @close="close">
    <div class="activity-detail">
      <div class="activity-detail__head">
        <span class="activity-detail__name">{{ detail.title }}</span>
        <span v-if="detail.filePath" class="activity-detail__path" :title="detail.filePath">
          {{ detail.filePath }}
        </span>
      </div>

      <section class="ov-card">
        <div class="ov-card__label">Input</div>
        <div v-if="detail.commandPreview" class="ov-command">{{ detail.commandPreview }}</div>
        <JsonTreeView v-if="showParamsTree" :value="detail.params" class="ov-tree" />
        <div v-else-if="!detail.commandPreview" class="ov-empty">无参数</div>
      </section>

      <section v-if="detail.output" class="ov-card">
        <div class="ov-card__label">{{ detail.output.label }}</div>
        <pre v-if="detail.output.kind === 'terminal'" class="ov-terminal">{{ detail.output.text }}</pre>
        <pre v-else-if="detail.output.kind === 'code'" class="ov-code">{{ detail.output.text }}</pre>
        <div v-else-if="detail.output.kind === 'document'" class="ov-document">{{ detail.output.text }}</div>
        <JsonTreeView v-else-if="detail.output.kind === 'json' && parsedOutput" :value="parsedOutput" class="ov-tree" />
        <pre v-else class="ov-text">{{ detail.output.text }}</pre>
      </section>
    </div>
  </CosmoClawTextOverlay>
</template>

<script>
import CosmoClawTextOverlay from './CosmoClawTextOverlay.vue'
import JsonTreeView from './JsonTreeView.vue'
import { buildActivityDetail } from '../utils/toolDetail'

export default {
  name: 'CosmoClawActivityOverlay',
  components: { CosmoClawTextOverlay, JsonTreeView },
  props: {
    // 要查看详情的工具消息；为 null 时不渲染
    msg: { type: Object, default: null }
  },
  computed: {
    detail() {
      return buildActivityDetail(this.msg)
    },
    parsedOutput() {
      const text = this.detail && this.detail.output && this.detail.output.text
      if (!text) return null
      try {
        const obj = JSON.parse(text)
        return obj && typeof obj === 'object' ? obj : null
      } catch (e) {
        return null
      }
    },
    // 命令行工具（含 command 参数）的 command 已在上方预览完整展示，
    // 参数树只会重复 command / intent，不再渲染
    showParamsTree() {
      const detail = this.detail
      if (!detail || !detail.hasParams) return false
      return !(detail.params && typeof detail.params.command === 'string' && detail.params.command)
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-detail {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.activity-detail__head {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 2px;
}

.activity-detail__name {
  font-size: 13px;
  font-weight: 500;
  color: #1f2329;
}

.activity-detail__path {
  font-size: 11px;
  color: #5b6f8f;
  background: #f2f5fa;
  border-radius: 4px;
  padding: 1px 6px;
  max-width: 420px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ov-card {
  border: 1px solid #eef0f4;
  border-radius: 10px;
  background: #fbfcfe;
  padding: 10px 12px 12px;
  min-width: 0;
}

.ov-card__label {
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #8f9bb3;
  margin-bottom: 8px;
}

.ov-command {
  font-family: 'Cascadia Code', 'Fira Code', 'JetBrains Mono', Consolas, monospace;
  font-size: 12px;
  line-height: 20px;
  color: #334155;
  background: #fff;
  border: 1px solid #eef0f4;
  border-radius: 6px;
  padding: 6px 8px;
  margin-bottom: 8px;
  white-space: pre-wrap;
  word-break: break-all;
}

.ov-tree {
  background: #fff;
  border: 1px solid #eef1f8;
  border-radius: 6px;
  padding: 6px 8px;
  max-height: 320px;
  overflow: auto;
}

.ov-terminal,
.ov-code,
.ov-text {
  margin: 0;
  font-family: 'Cascadia Code', 'Fira Code', 'JetBrains Mono', Consolas, monospace;
  font-size: 12px;
  line-height: 1.7;
  color: #334155;
  background: #fff;
  border: 1px solid #eef1f8;
  border-radius: 6px;
  padding: 10px 12px;
  max-height: 420px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
}

.ov-terminal {
  background: #0f172a;
  border-color: #0f172a;
  color: #d7e2f1;
}

.ov-document {
  font-size: 13px;
  line-height: 1.8;
  color: #334155;
  background: #fff;
  border: 1px solid #eef1f8;
  border-radius: 6px;
  padding: 10px 12px;
  max-height: 420px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
}

.ov-empty {
  font-size: 12px;
  color: #94a3b8;
}
</style>
